export class TranslateLanguagePage {
  idTranslateLanguagePage: number;
  idLanguagePage: number;
  idLanguage: number;
  title: string;
  breadCrumb: string;
  locked: boolean;

  constructor(
    idTranslateLanguagePage: number,
    idLanguagePage: number,
    idLanguage: number,
    title: string,
    breadCrumb: string,
    locked: boolean,
  ) {
    this.idTranslateLanguagePage = idTranslateLanguagePage;
    this.idLanguagePage = idLanguagePage;
    this.idLanguage = idLanguage;
    this.title = title;
    this.breadCrumb = breadCrumb;
    this.locked = locked;
  }

  static fromRaw(raw: any): TranslateLanguagePage {
    return new TranslateLanguagePage(
      Number(raw.idTranslateLanguagePage),
      Number(raw.idLanguagePage),
      Number(raw.idLanguage),
      String(raw.title),
      String(raw.breadCrumb),
      Boolean(raw.locked),
    );
  }

  clone(): TranslateLanguagePage {
    return new TranslateLanguagePage(
      this.idTranslateLanguagePage,
      this.idLanguagePage,
      this.idLanguage,
      this.title,
      this.breadCrumb,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idLanguagePage: this.idLanguagePage,
      idLanguage: this.idLanguage,
      title: this.title,
      breadCrumb: this.breadCrumb,
    };
    if (this.idTranslateLanguagePage !== 0) {
      payload.idTranslateLanguagePage = this.idTranslateLanguagePage;
    }
    return payload;
  }
}
